'kiwi public';

import _asyncToGenerator from "@babel/runtime-corejs3/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import * as TextFormatting from '@/helpers/TextFormatting';
import getState from '@/libs/state';
import _aboutContent from './about.html';
var firstRun = true;
var ctor = {
  data: function data() {
    return {
      about_open: false
    };
  },
  computed: {
    networks: function networks() {
      return this.$state.networks;
    },
    aboutContent: function aboutContent() {
      return _aboutContent;
    }
  },
  methods: {
    addNetwork: function addNetwork() {
      var nick = 'Guest' + Math.floor(Math.random() * 100);
      var network = this.$state.addNetwork(TextFormatting.t('new_network'), nick, {});
      network.showServerBuffer('settings');
    },
    toggleStateBrowser: function toggleStateBrowser() {
      this.$state.$emit('statebrowser.show');
    },
    init: function init() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.$state.persistence.watchStateForChanges();
              _this.$emit('start', {
                fallbackComponent: _this.constructor
              });
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  },
  created: function () {
    var _created = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (firstRun) {
              this.init();
              firstRun = false;
            }
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    }));
    function created() {
      return _created.apply(this, arguments);
    }
    return created;
  }()
};
export default ctor;
getState().getStartups().kiwiirccom = ctor;
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["thirdparty"]) window._kiwi_exports["thirdparty"] = {};
window._kiwi_exports["thirdparty"]["kiwiirccom"]
window._kiwi_exports.thirdparty.kiwiirccom = (typeof exports !== 'undefined' ? (exports.default || exports) : (typeof module !== 'undefined' && module.exports ? (module.exports.default || module.exports) : {}));
